import React from 'react';
import SelectCustomers from '@components/SelectCustomers';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { DefaultOptionType } from 'antd/lib/select';

interface ICustomerStep {
  value: number | undefined;
  onChange?:
    | ((value: any, option?: DefaultOptionType | DefaultOptionType[]) => void)
    | undefined;
  showMessage?: boolean;
}

const CustomerStep = ({
  value,
  onChange,
  showMessage = false,
}: ICustomerStep) => {
  const { t } = useTranslation('requests');

  return (
    <Row gutter={[16, 16]} justify="center">
      <Col lg={16} xl={16} xs={24}>
        <SelectCustomers value={value} onChange={onChange} />

        {showMessage && (
          <div
            style={{
              marginTop: 4,
              color: 'red',
              fontSize: '0.8rem',
              textAlign: 'left',
            }}
          >
            {`* ${t('clientWithoutContracts')}`}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default CustomerStep;
